import SuperAdminMenu from './SuperAdminMenu'

export default SuperAdminMenu


// WEBPACK FOOTER //
// ./src/components/SuperAdminMenu/index.jsx